<template>
  <div class="entity-status">
    <h4>Estado de la habilitación</h4>
    <div class="status-form">
      <div class="input-group">
        <select name="selectCategoryList"
                v-validate="'required'"
                v-model="state"
                :class="{changed: !!(state)}">
          <option value="" disabled>Estado</option>
          <option v-for="state in possibleStates" :value="state" :key="state">{{ $t(`possibleStates.${state}`) }}</option>
        </select>
        <label for="selectCategoryList">Estado</label>
      </div>

      <div class="input-group">
        <textarea name="motive" placeholder="Motivo (opcional)" v-model="motive" :class="{changed: !!(motive)}" rows="5"/>
        <label for="motive">Motivo (opcional)</label>
      </div>

      <button class="btn btn--large success" @click="changeState" :class="{'btn--loading': loading}">Actualizar estado</button><br>
    </div>

    <div v-if="history">
      <h4>Historial de Cambios</h4>
      <table class="n-table bordered fixed">
        <thead>
          <th>Fecha de modificación</th>
          <th>Estado</th>
          <th>Usuario admin</th>
          <th>Motivo</th>
        </thead>
        <tbody>
          <tr class="establishment" v-for="(hist, index) in history" :key="index">
            <td data-label="Fecha de modificación">{{ localeDate(hist.createdAt) }}</td>
            <td data-label="Estado">{{ hist.currentState ? $t(`history.reify.registrationState.${hist.currentState}`) : '-' }}</td>
            <td data-label="Usuario admin">{{ hist.whodunnit }}</td>
            <td data-label="Motivo">
              <div class="data-wrapper">{{ hist.motive }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'
import Vue from 'vue'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

const changeState = gql`
  mutation changeState ($currentUserToken: String!, $organizationId: Int!, $action: String!, $motive:String) {
    changeState (currentUserToken: $currentUserToken, organizationId: $organizationId, action:$action, motive: $motive) {
      code
      codes
      message
      success
    }
  }
`
const organizationStateHistory = gql`
  query organizationStateHistory($currentUserToken: String!, $organizationId: Int) {
    organizationStateHistory(currentUserToken: $currentUserToken, organizationId: $organizationId) {
      createdAt
      currentState
      motive
      whodunnit
    }
  }
`
const possibleStates = gql`
  query possibleStates ($currentUserToken: String, $organizationId: Int) {
    possibleStates (currentUserToken: $currentUserToken, organizationId: $organizationId){
      possibleStates
    }
  }
`

export default {
  name: 'organization-state',
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      history: [],
      state: '',
      motive: '',
      selectCategoryList: [],
      possibleStates: [],
      loading: false
    }
  },
  beforeMount() {
    this.getStateHistory()
    this.getPossibleStates()
  },
  watch: {
    currentUser() {
      this.getStateHistory()
      this.getPossibleStates()
    }
  },
  methods: {
    getStateHistory() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(organizationStateHistory),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          organizationId: this.organization.id
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.history = res.data.data.organizationStateHistory
        } else {
          console.log(res.data.errors)
        }
      })
    },
    changeState() {
      this.loading = true
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(changeState),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          organizationId: this.organization.id,
          action: this.state,
          motive: this.motive
        }
      }).then(res => {
        if (!res.data.errors){
          if (res.data.data.changeState.success) {
            this.motive = ''
            this.getStateHistory()
            this.getPossibleStates()
          }
        } else {
          console.log(res.data.errors)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    getPossibleStates() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(possibleStates),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          organizationId: this.organization.id
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.possibleStates = res.data.data.possibleStates.possibleStates
        }
      }).catch(err => {
        console.log(err)
      })
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e+6*3).toLocaleDateString()
    //  return (new Date(str.replace(/-0300/, '').trim())).toLocaleString()
    }
  },
}
</script>
